export default "__VITE_ASSET__51d44e16__"